import { createSlice } from '@reduxjs/toolkit';
import { AuthState } from './types';

const initialState: AuthState = {
  token: null,
  isAuthenticated: false,
  userInfo: {
    name: null,
    role: null,
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.token = action.payload.token;
      state.userInfo = action.payload.userInfo;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.token = null;
      state.userInfo = { name: null, role: null };
      state.isAuthenticated = false;
    },
    updateToken: (state, action) => {
      state.token = action.payload.token;
    },
    updateUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
  },
});

export const { login, logout, updateToken, updateUserInfo } = authSlice.actions;

export const authReducer = authSlice.reducer;
